import { Material } from '@/app/entities/Material'
import { useState } from 'react'
import { MaterialsList } from './MaterialsList'
import { SelectedMaterial } from './SelectedMaterial'
import { materialIsClosed } from '../MaterialPage/helper'

interface MaterialsContainerProps {
  materials: Material[]
}

export const MaterialsContainer = ({ materials }: MaterialsContainerProps) => {
  const [selectedMaterial, setSelectedMaterial] = useState<Material | null>(
    () => materials.find((m) => !materialIsClosed(m)) || null,
  )

  return (
    <div className="flex flex-row gap-8">
      <SelectedMaterial material={selectedMaterial} />
      <MaterialsList
        selectedMaterial={selectedMaterial}
        materials={materials}
        onSelectMaterial={setSelectedMaterial}
      />
    </div>
  )
}
